/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Partner
 */
export interface Partner {
    /**
     * 
     * @type {number}
     * @memberof Partner
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof Partner
     */
    active: boolean;
}

/**
 * Check if a given object implements the Partner interface.
 */
export function instanceOfPartner(value: object): value is Partner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function PartnerFromJSON(json: any): Partner {
    return PartnerFromJSONTyped(json, false);
}

export function PartnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Partner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'active': json['active'],
    };
}

export function PartnerToJSON(json: any): Partner {
    return PartnerToJSONTyped(json, false);
}

export function PartnerToJSONTyped(value?: Partner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
    };
}

